import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsQtComponent } from './simple-icons-qt.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsQtComponent ],
    exports:      [ SimpleIconsQtComponent ],
    bootstrap:    []
})
export class SimpleIconsQtModule {}
